<div>
    <div fxLayout="row wrap" fxLayoutAlign="center" fxFlex="100" style="margin-top: 20px;">
      <div fxLayoutAlign="center"  class="ps-form-container">
        <app-form-render style="flex:1 1 0%;" [previousSubmissionDataFromPopUp]="previousSubmissionData" [defaultColor]="defaultColor" [lgpdDataFromPopUp]="lgpdDataFromPopUp" [content]="popup.content" [data]="popup" [type]="2"></app-form-render>
      </div>
    </div>
</div>
